/**
 * Native Navigation — singleton router reference for Capacitor navigation.
 *
 * NativeAppInit, deep-link listeners, and push notification handlers run
 * outside React component trees and can't call useRouter().  This module
 * stores a reference to Next.js router.push() that layout.tsx sets on mount,
 * so all native navigation goes through client-side routing instead of
 * window.location.href (which causes full page reloads and state loss).
 */

type NavigateFn = (path: string) => void;

let _navigate: NavigateFn | null = null;

/** Called once from layout.tsx to register the router.push reference */
export function registerNavigate(fn: NavigateFn): void {
  _navigate = fn;
}

/** Navigate using client-side routing (falls back to location.href on web) */
export function navigateTo(path: string): void {
  if (_navigate) {
    _navigate(path);
  } else {
    window.location.href = path;
  }
}
